
import { Link } from "react-router-dom";

export const QuickLinks = () => {
  const links = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Contact Us", path: "/contact" },
    { name: "For Professionals", path: "/for-pros" },
    { name: "Advertise With Us", path: "/advertise-with-us" },
  ];

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div className="md:col-span-3">
      <h3 className="font-semibold mb-4 text-white">Quick Links</h3>
      <ul className="space-y-3 text-sm text-white/80">
        {links.map((link) => (
          <li key={link.name}>
            <Link 
              to={link.path}
              className="hover:text-white transition-colors"
              onClick={handleClick}
            >
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
